// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"299584e5","488":"29b71886","497":"46976ec6","511":"113f2cad","727":"744276f1","892":"a3b0b914"}[chunkId] + ".chunk.js";
};